import { Component } from '@angular/core';
import { SharedDataService } from '../../../../shared/service/shared-data/shared-data.service';
@Component({
  selector: 'app-search-sidebar',
  templateUrl: './search-sidebar.component.html',
  styleUrl: './search-sidebar.component.scss',
})
export class SearchSidebarComponent {
  isSidebarVisible = false;

  constructor(private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    this.sharedDataService.searchSidebarVisibility$.subscribe((visible) => {
      this.isSidebarVisible = visible;
    });
  }
  
  toggleSidebar() {
    this.sharedDataService.toggleSearchSidebar();
  }
}
